// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kbSearchListItem__itemContainer___37gy3{display:flex;background-color:#fff;flex-grow:1;cursor:pointer;padding:0 0 0 20px}.kbSearchListItem__itemContainer___37gy3.kbSearchListItem__isLast___JtkWN{border-bottom:.5px solid #e9eff5}.kbSearchListItem__itemContainer___37gy3:hover{background-color:#f3f5f8}.kbSearchListItem__container___3X4Kq{height:75px;width:100%;border-bottom:1px solid #e9eff5;padding:0 20px 0 0;display:flex;justify-content:space-between;align-items:center}.kbSearchListItem__container___3X4Kq.kbSearchListItem__isLast___JtkWN{border-bottom:0}.kbSearchListItem__details___23Bye{display:flex;min-width:100px}.kbSearchListItem__itemIcon___3C1BJ{margin:0 10px 0 0;color:#b8b8b8;width:18px;height:18px;flex-shrink:0}.kbSearchListItem__information___33gj5{display:flex;flex-direction:column;white-space:nowrap;overflow:hidden}.kbSearchListItem__description___1KeCy{font-size:12px;color:#717070;margin-top:10px;overflow:hidden;text-overflow:ellipsis}.kbSearchListItem__chevronIcon___16Mgo{color:#979797;flex-shrink:0}html[dir=\"rtl\"] .kbSearchListItem__itemContainer___37gy3{padding:0 20px 0 0}html[dir=\"rtl\"] .kbSearchListItem__container___3X4Kq{padding:0 0 0 20px}html[dir=\"rtl\"] .kbSearchListItem__itemIcon___3C1BJ{margin:0 0 0 10px}html[dir=\"rtl\"] .kbSearchListItem__chevronIcon___16Mgo{transform:rotate(180deg)}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"itemContainer": "kbSearchListItem__itemContainer___37gy3",
	"isLast": "kbSearchListItem__isLast___JtkWN",
	"container": "kbSearchListItem__container___3X4Kq",
	"details": "kbSearchListItem__details___23Bye",
	"itemIcon": "kbSearchListItem__itemIcon___3C1BJ",
	"information": "kbSearchListItem__information___33gj5",
	"description": "kbSearchListItem__description___1KeCy",
	"chevronIcon": "kbSearchListItem__chevronIcon___16Mgo"
};
module.exports = exports;
